var cov_2g2ywyxrrz = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Input/Password.tsx",
      hash = "9c994295cf536cb3b3b0cd9d3193fdf32fe8e2b9",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Input/Password.tsx",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 21
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 16
        }
      },
      "2": {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 15,
          column: 52
        }
      },
      "3": {
        start: {
          line: 19,
          column: 89
        },
        end: {
          line: 19,
          column: 99
        }
      },
      "4": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 23,
          column: 5
        }
      },
      "5": {
        start: {
          line: 21,
          column: 6
        },
        end: {
          line: 21,
          column: 36
        }
      },
      "6": {
        start: {
          line: 22,
          column: 6
        },
        end: {
          line: 22,
          column: 12
        }
      },
      "7": {
        start: {
          line: 24,
          column: 31
        },
        end: {
          line: 24,
          column: 33
        }
      },
      "8": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 27,
          column: 6
        }
      },
      "9": {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 26,
          column: 47
        }
      },
      "10": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 42
        }
      },
      "11": {
        start: {
          line: 33,
          column: 82
        },
        end: {
          line: 33,
          column: 92
        }
      },
      "12": {
        start: {
          line: 34,
          column: 23
        },
        end: {
          line: 34,
          column: 89
        }
      },
      "13": {
        start: {
          line: 34,
          column: 74
        },
        end: {
          line: 34,
          column: 79
        }
      },
      "14": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 92
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 13,
            column: 3
          }
        },
        loc: {
          start: {
            line: 13,
            column: 36
          },
          end: {
            line: 16,
            column: 3
          }
        },
        line: 13
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 3
          }
        },
        loc: {
          start: {
            line: 18,
            column: 28
          },
          end: {
            line: 30,
            column: 3
          }
        },
        line: 18
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 25,
            column: 26
          },
          end: {
            line: 25,
            column: 27
          }
        },
        loc: {
          start: {
            line: 25,
            column: 36
          },
          end: {
            line: 27,
            column: 5
          }
        },
        line: 25
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 3
          }
        },
        loc: {
          start: {
            line: 32,
            column: 11
          },
          end: {
            line: 36,
            column: 3
          }
        },
        line: 32
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 34,
            column: 68
          },
          end: {
            line: 34,
            column: 69
          }
        },
        loc: {
          start: {
            line: 34,
            column: 74
          },
          end: {
            line: 34,
            column: 79
          }
        },
        line: 34
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 19,
            column: 12
          },
          end: {
            line: 19,
            column: 38
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 19,
            column: 20
          },
          end: {
            line: 19,
            column: 38
          }
        }],
        line: 19
      },
      "1": {
        loc: {
          start: {
            line: 19,
            column: 40
          },
          end: {
            line: 19,
            column: 66
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 19,
            column: 48
          },
          end: {
            line: 19,
            column: 66
          }
        }],
        line: 19
      },
      "2": {
        loc: {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 23,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 23,
            column: 5
          }
        }, {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 23,
            column: 5
          }
        }],
        line: 20
      },
      "3": {
        loc: {
          start: {
            line: 20,
            column: 8
          },
          end: {
            line: 20,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 8
          },
          end: {
            line: 20,
            column: 25
          }
        }, {
          start: {
            line: 20,
            column: 29
          },
          end: {
            line: 20,
            column: 45
          }
        }],
        line: 20
      },
      "4": {
        loc: {
          start: {
            line: 26,
            column: 20
          },
          end: {
            line: 26,
            column: 46
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 26,
            column: 34
          },
          end: {
            line: 26,
            column: 42
          }
        }, {
          start: {
            line: 26,
            column: 45
          },
          end: {
            line: 26,
            column: 46
          }
        }],
        line: 26
      },
      "5": {
        loc: {
          start: {
            line: 33,
            column: 12
          },
          end: {
            line: 33,
            column: 38
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 33,
            column: 20
          },
          end: {
            line: 33,
            column: 38
          }
        }],
        line: 33
      },
      "6": {
        loc: {
          start: {
            line: 33,
            column: 40
          },
          end: {
            line: 33,
            column: 66
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 33,
            column: 48
          },
          end: {
            line: 33,
            column: 66
          }
        }],
        line: 33
      },
      "7": {
        loc: {
          start: {
            line: 34,
            column: 45
          },
          end: {
            line: 34,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 34,
            column: 45
          },
          end: {
            line: 34,
            column: 50
          }
        }, {
          start: {
            line: 34,
            column: 54
          },
          end: {
            line: 34,
            column: 56
          }
        }],
        line: 34
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0],
      "6": [0],
      "7": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Input/Password.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import Input from './Input';
var DefaultValue = (cov_2g2ywyxrrz.s[0]++, {
  value: '',
  point: '•'
});

var Password =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Password, _PureComponent);

  var _super = _createSuper2(Password);

  function Password(props) {
    var _this;

    _classCallCheck(this, Password);

    cov_2g2ywyxrrz.f[0]++;
    cov_2g2ywyxrrz.s[1]++;
    _this = _super.call(this, props);
    cov_2g2ywyxrrz.s[2]++;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Password, [{
    key: "handleChange",
    value: function handleChange(val) {
      cov_2g2ywyxrrz.f[1]++;

      var _ref = (cov_2g2ywyxrrz.s[3]++, this.props),
          _ref$value = _ref.value,
          value = _ref$value === void 0 ? (cov_2g2ywyxrrz.b[0][0]++, DefaultValue.value) : _ref$value,
          _ref$point = _ref.point,
          point = _ref$point === void 0 ? (cov_2g2ywyxrrz.b[1][0]++, DefaultValue.point) : _ref$point,
          clearToUndefined = _ref.clearToUndefined;

      cov_2g2ywyxrrz.s[4]++;

      if ((cov_2g2ywyxrrz.b[3][0]++, val === undefined) && (cov_2g2ywyxrrz.b[3][1]++, clearToUndefined)) {
        cov_2g2ywyxrrz.b[2][0]++;
        cov_2g2ywyxrrz.s[5]++;
        this.props.onChange(undefined);
        cov_2g2ywyxrrz.s[6]++;
        return;
      } else {
        cov_2g2ywyxrrz.b[2][1]++;
      }

      var newValue = (cov_2g2ywyxrrz.s[7]++, []);
      cov_2g2ywyxrrz.s[8]++;
      val.split('').forEach(function (v, i) {
        cov_2g2ywyxrrz.f[2]++;
        cov_2g2ywyxrrz.s[9]++;
        newValue.push(v === point ? (cov_2g2ywyxrrz.b[4][0]++, value[i]) : (cov_2g2ywyxrrz.b[4][1]++, v));
      });
      cov_2g2ywyxrrz.s[10]++;
      this.props.onChange(newValue.join(''));
    }
  }, {
    key: "render",
    value: function render() {
      cov_2g2ywyxrrz.f[3]++;

      var _ref2 = (cov_2g2ywyxrrz.s[11]++, this.props),
          _ref2$point = _ref2.point,
          point = _ref2$point === void 0 ? (cov_2g2ywyxrrz.b[5][0]++, DefaultValue.point) : _ref2$point,
          _ref2$value = _ref2.value,
          value = _ref2$value === void 0 ? (cov_2g2ywyxrrz.b[6][0]++, DefaultValue.value) : _ref2$value,
          others = _objectWithoutProperties(_ref2, ["point", "value"]);

      var transValue = (cov_2g2ywyxrrz.s[12]++, Array.from({
        length: ((cov_2g2ywyxrrz.b[7][0]++, value) || (cov_2g2ywyxrrz.b[7][1]++, '')).length
      }, function () {
        cov_2g2ywyxrrz.f[4]++;
        cov_2g2ywyxrrz.s[13]++;
        return point;
      }).join(''));
      cov_2g2ywyxrrz.s[14]++;
      return (
        /*#__PURE__*/
        React.createElement(Input, Object.assign({}, others, {
          type: "text",
          value: transValue,
          onChange: this.handleChange,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 35,
            columnNumber: 12
          }
        }))
      );
    }
  }]);

  return Password;
}(PureComponent);

Password.defaultProps = DefaultValue;
export default Password;